module.exports = __webpack_public_path__ + "img/monitoring.7d0d87fa.svg";